import {useDebounceFn} from '@vueuse/core';

type DebouncedEventQueueOptions = {
  wait?: number;
  maxWait?: number;
};

/**
 * Collects websocket events and processes them in debounced batches.
 *
 * A burst of events (e.g. a CSV import creating many orders at once) is
 * coalesced into a single flush, so the store isn't updated on every message.
 */
export const createDebouncedEventQueue = <TEvent>(
  process: (event: TEvent) => void,
  {wait = 100, maxWait = 250}: DebouncedEventQueueOptions = {},
) => {
  let queue: TEvent[] = [];

  const flushQueue = useDebounceFn(
    () => {
      const batch = queue;
      queue = [];
      batch.forEach(process);
    },
    wait,
    {maxWait},
  );

  return (event: TEvent): void => {
    queue.push(event);
    void flushQueue();
  };
};
